// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_wrapper__MmwlH {
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  width: 85%;
  margin: 0 auto;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic__hkEFh {
  display: block;
  min-height: 620px;
  height: 100%;
  object-fit: cover;
  margin: 0 auto;
  max-width: 671px;
  width: 100%;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_mid__KN0yn {
  display: none;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_mob__htVz7 {
  display: none;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 10px;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title__dp61k {
  font-family: "Open Sans Bold";
  font-size: 48px;
  letter-spacing: 0em;
  color: #faf9f8;
  line-height: 1.1em;
  white-space: nowrap;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title__dp61k span {
  color: #F2F740;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title2__-fMQv {
  font-family: "Open Sans Regular";
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0em;
  color: #faf9f8;
  line-height: 1.2em;
  width: 90%;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title2__-fMQv span {
  color: #F2F740;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_subtitle__\\+JtlB {
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_btn__7nmSS {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  border-radius: 12px;
  min-width: 104px;
  min-height: 42px;
  background: #f2f740;
  line-height: 130%;
  text-transform: capitalize;
  color: #292621;
  cursor: pointer;
  margin-top: 16px;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_btn__7nmSS:hover {
  background-color: #f5f966;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_btn__7nmSS:active {
  background-color: #e6eb3d;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_wrapper__sDvc\\+ {
  margin-top: 30px;
  width: 50%;
  display: flex;
  justify-content: end;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_wrapper__sDvc\\+ img {
  width: 100%;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD {
  color: #ffffff;
  z-index: 2;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_title__dp61k {
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 20px;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_subtitle__\\+JtlB {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  margin-bottom: 24px;
  width: 45%;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_btn__7nmSS {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 22px;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_reg__hctpL {
  background-color: #ead40c;
  color: #1b1e23;
}
.Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_platforms__5bDmO {
  align-items: center;
  display: flex;
  gap: 32px;
  margin-top: 40px;
}
.Banner_wrapper__MmwlH .Banner_banner__C5Dci {
  display: none;
}

@media (max-width: 1442px) {
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq {
    margin-top: 40px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title__dp61k {
    font-size: 48px;
    letter-spacing: -0.02em;
  }
}
@media (max-width: 1100px) {
  .Banner_wrapper__MmwlH {
    background-image: none !important;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W {
    display: block;
    padding-top: 100px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq {
    width: 100%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_wrapper__sDvc\\+ {
    width: 100%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_title__dp61k {
    width: 50%;
  }
}
@media (max-width: 850px) {
  .Banner_wrapper__MmwlH {
    display: block;
    padding-top: 65px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv {
    height: unset;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W {
    padding-top: unset;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq {
    margin-left: 50px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_title__dp61k {
    font-size: 48px;
    font-weight: 700;
    font-style: normal;
    width: 100%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_subtitle__\\+JtlB {
    width: 90%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_platforms__5bDmO img {
    width: 180px;
  }
  .Banner_wrapper__MmwlH .Banner_bannerDesk__pjaIy {
    display: none;
  }
  .Banner_wrapper__MmwlH .Banner_banner__C5Dci {
    display: block;
  }
  .Banner_wrapper__MmwlH .Banner_banner__C5Dci img {
    width: 100%;
  }
}
@media (max-width: 679px) {
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W {
    margin-left: 0px;
    margin-top: 5px;
    padding: 0px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;
    width: 100%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_mob__htVz7 {
    display: block;
    margin-top: 30px;
    width: 100%;
    height: 100%;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_banner_pic_mid__KN0yn {
    display: none;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq {
    align-items: center;
    gap: 7px;
    margin-left: 0px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_btn__7nmSS {
    place-self: center;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_subtitle__\\+JtlB {
    font-size: 20px;
    font-weight: 400;
    font-style: normal;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_title__dp61k {
    font-size: 30px;
    text-align: center;
    white-space: normal;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_section__yUd6W .Banner_group__ER5hq .Banner_btn__7nmSS {
    font-size: 16px;
    margin-top: 16px;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD {
    z-index: 0;
  }
  .Banner_wrapper__MmwlH .Banner_info__rVYdv .Banner_container__yH8MD .Banner_platforms__5bDmO img {
    width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/components/Banner/Banner.module.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,4BAAA;EACA,sBAAA;AADF;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,UAAA;EACA,cAAA;AAFN;AAIM;EACE,cAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,aAAA;AAJR;AAOM;EAEE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AANR;AAQQ;EACE,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AANV;AAQU;EACE,cCSM;ADflB;AAUQ;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AARV;AAUU;EACE,cCLM;ADHlB;AAWQ;EE3CN,eAAA;EACA,gBAAA;EACA,kBAAA;EF4CQ,cAAA;AARV;AAWQ;EErCN,eAAA;EACA,gBAAA;EACA,kBAAA;EFqCQ,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAPV;AASU;EACE,yBAAA;AAPZ;AAUU;EACE,yBAAA;AARZ;AAaM;EACE,gBAAA;EACA,UAAA;EAEA,aAAA;EACA,oBAAA;AAZR;AAcQ;EACE,WAAA;AAZV;AAiBI;EACE,cAAA;EACA,UAAA;AAfN;AAiBM;EEjHJ,eAAA;EACA,gBAAA;EACA,kBAAA;EFiHM,mBAAA;AAbR;AAgBM;EE5EJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF4EM,iBAAA;EACA,mBAAA;EACA,UAAA;AAZR;AAeM;EE7EJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF6EM,kBAAA;EACA,eAAA;EACA,kBAAA;AAXR;AAcM;EACE,yBAAA;EACA,cAAA;AAZR;AAeM;EGrIJ,mBAAA;EACA,aAAA;EHsIM,SAAA;EACA,gBAAA;AAZR;AAiBE;EACE,aAAA;AAfJ;;AA2BA;EAIQ;IACE,gBAAA;EA3BR;EA6BQ;IACE,eAAA;IACA,uBAAA;EA3BV;AACF;AAkCA;EACE;IACE,iCAAA;EAhCF;EAkCI;IACE,cAAA;IACA,kBAAA;EAhCN;EAkCM;IACE,WAAA;EAhCR;EAmCM;IACE,WAAA;EAjCR;EAsCM;IACE,UAAA;EApCR;AACF;AA0CA;EACE;IACE,cAAA;IACA,iBAAA;EAxCF;EA0CE;IACE,aAAA;EAxCJ;EA0CI;IACE,kBAAA;EAxCN;EAyCM;IACE,iBAAA;EAvCR;EA4CM;IEnNN,eAAA;IACA,gBAAA;IACA,kBAAA;IFmNQ,WAAA;EAxCR;EA2CM;IACE,UAAA;EAzCR;EA6CQ;IACE,YAAA;EA3CV;EAiDE;IACE,aAAA;EA/CJ;EAkDE;IACE,cAAA;EAhDJ;EAkDI;IACE,WAAA;EAhDN;AACF;AAqDA;EAGM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;EArDN;EAuDM;IACE,cAAA;IACA,gBAAA;IAEA,WAAA;IACA,YAAA;EAtDR;EAyDM;IACE,aAAA;EAvDR;EA0DM;IACE,mBAAA;IACA,QAAA;IACA,gBAAA;EAxDR;EA0DQ;IACE,kBAAA;EAxDV;EA2DQ;IEhPR,eAAA;IACA,gBAAA;IACA,kBAAA;EFwLA;EA0DQ;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;EAxDV;EA2DQ;IACE,eAAA;IACA,gBAAA;EAzDV;EA8DI;IACE,UAAA;EA5DN;EA+DQ;IACE,YAAA;EA7DV;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.wrapper {\n  position: relative;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n  .info {\n    .section {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      justify-content: space-between;\n      width: 85%;\n      margin: 0 auto;\n\n      .banner_pic {\n        display: block;\n        min-height: 620px;\n        height: 100%;\n        object-fit: cover;\n        margin: 0 auto;\n        max-width: 671px;\n        width: 100%;\n      }\n\n      .banner_pic_mid {\n        display: none;\n      }\n\n      .banner_pic_mob {\n        display: none;\n      }\n\n      .group {\n        // max-width: 820px;\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        align-items: baseline;\n        gap: 10px;\n\n        .title {\n          font-family: \"Open Sans Bold\";\n          font-size: 48px;\n          letter-spacing: 0em;\n          color: #faf9f8;\n          line-height: 1.1em;\n          white-space: nowrap;\n\n          span {\n            color: $control-primary;\n          }\n        }\n\n        .title2 {\n          font-family: \"Open Sans Regular\";\n          font-size: 24px;\n          font-weight: 400;\n          letter-spacing: 0em;\n          color: #faf9f8;\n          line-height: 1.2em;\n          width: 90%;\n\n          span {\n            color: $control-primary;\n          }\n        }\n        .subtitle {\n          @include subtitle2m;\n\n          color: #ffffff;\n        }\n\n        .btn {\n          @include subtitle4m;\n          font-size: 16px;\n          border-radius: 12px;\n          min-width: 104px;\n          min-height: 42px;\n          background: #f2f740;\n          line-height: 130%;\n          text-transform: capitalize;\n          color: #292621;\n          cursor: pointer;\n          margin-top: 16px;\n\n          &:hover {\n            background-color: #f5f966;\n          }\n\n          &:active {\n            background-color: #e6eb3d;\n          }\n        }\n      }\n\n      .banner_pic_wrapper {\n        margin-top: 30px;\n        width: 50%;\n\n        display: flex;\n        justify-content: end;\n\n        img {\n          width: 100%;\n        }\n      }\n    }\n\n    .container {\n      color: #ffffff;\n      z-index: 2;\n\n      .title {\n        @include h1;\n        margin-bottom: 20px;\n      }\n\n      .subtitle {\n        @include subtitle5;\n        line-height: 120%;\n        margin-bottom: 24px;\n        width: 45%;\n      }\n\n      .btn {\n        @include subtitle6m;\n        border-radius: 8px;\n        cursor: pointer;\n        padding: 10px 22px;\n      }\n\n      .reg {\n        background-color: #ead40c;\n        color: #1b1e23;\n      }\n\n      .platforms {\n        @include df-aic;\n        gap: 32px;\n        margin-top: 40px;\n      }\n    }\n  }\n\n  .banner {\n    display: none;\n  }\n}\n\n@media (max-width: 1589px) {\n  .wrapper {\n    .info {\n      .section {}\n    }\n  }\n}\n\n@media (max-width: 1442px) {\n  .wrapper {\n    .info {\n      .section {\n        .group {\n          margin-top: 40px;\n\n          .title {\n            font-size: 48px;\n            letter-spacing: -0.02em;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n    background-image: none !important;\n    .info {\n      .section {\n        display: block;\n        padding-top: 100px;\n        \n        .group {\n          width: 100%;\n        }\n\n        .banner_pic_wrapper {\n          width: 100%;\n        }\n      }\n\n      .container {\n        .title {\n          width: 50%;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    display: block;\n    padding-top: 65px;\n\n    .info {\n      height: unset;\n\n      .section {\n        padding-top: unset;\n        .group {\n          margin-left: 50px;\n        }\n      }\n\n      .container {\n        .title {\n          @include h2;\n          width: 100%;\n        }\n\n        .subtitle {\n          width: 90%;\n        }\n\n        .platforms {\n          img {\n            width: 180px;\n          }\n        }\n      }\n    }\n\n    .bannerDesk {\n      display: none;\n    }\n\n    .banner {\n      display: block;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 679px) {\n  .wrapper {\n    .info {\n      .section {\n        margin-left: 0px;\n        margin-top: 5px;\n        padding: 0px 10px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 0px;\n        width: 100%;\n\n        .banner_pic_mob {\n          display: block;\n          margin-top: 30px;\n\n          width: 100%;\n          height: 100%;\n        }\n\n        .banner_pic_mid {\n          display: none;\n        }\n\n        .group {\n          align-items: center;\n          gap: 7px;\n          margin-left: 0px;\n\n          .btn {\n            place-self: center;\n          }\n\n          .subtitle {\n            @include subtitle5;\n          }\n\n          .title {\n            font-size: 30px;\n            text-align: center;\n            white-space: normal;\n          }\n\n          .btn {\n            font-size: 16px;\n            margin-top: 16px;\n          }\n        }\n      }\n\n      .container {\n        z-index: 0;\n\n        .platforms {\n          img {\n            width: 150px;\n          }\n        }\n      }\n    }\n  }\n}","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #EAD40C;\n$icon-secondary: #7B756B;\n$icon-chevron: #BBB5AA;\n$icon-always-dark: #212329;\n$icon-primary-control: #292621;\n$icon-hover: #575249;\n$icon-pressed: #575249;\n$icon-white: #ffffff;\n$icon-notification: #FF3333;\n$icon-warning: #E2B603;\n$icon-deposit: #009E69;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #171716;\n$background-secondary: #292621;\n$background-snackbar: #000000;\n$background-input: #3E3C37;\n\n$control-primary: #F2F740;\n$control-hover: #F5F966;\n$control-pressed: #E6EB3D;\n$control-green: #009E69;\n$control-green-hover: #33B187;\n$control-green-pressed: #009664;\n$control-dark: #3E3C37;\n$control-dark-hover: #51504B;\n$control-dark-pressed: #3B3934;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n\n$text-title: #FAF9F8;\n$text-subtitle: #DAD6CE;\n$text-body: #C2BDB2;\n$text-link: #00D68F;\n$text-error: #FF3333;\n$text-warning: #E2B603;\n$text-white: #FFFFFF;\n$text-dark: #292621;","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}","@mixin df {\n  display: flex;\n}\n\n@mixin df-aic {\n  align-items: center;\n  display: flex;\n}\n\n@mixin df-aic-g8 {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n@mixin df-aic-jcc {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n@mixin df-aic-jcsb {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n@mixin hoverYellow {\n  transition: all .2s linear;\n\n  &:hover {\n    color: $c-yellow;\n  }\n}\n\n@mixin borderYellow {\n  border: 1px solid #F2F740;;\n  transition: all .2s linear;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Banner_wrapper__MmwlH`,
	"info": `Banner_info__rVYdv`,
	"section": `Banner_section__yUd6W`,
	"banner_pic": `Banner_banner_pic__hkEFh`,
	"banner_pic_mid": `Banner_banner_pic_mid__KN0yn`,
	"banner_pic_mob": `Banner_banner_pic_mob__htVz7`,
	"group": `Banner_group__ER5hq`,
	"title": `Banner_title__dp61k`,
	"title2": `Banner_title2__-fMQv`,
	"subtitle": `Banner_subtitle__+JtlB`,
	"btn": `Banner_btn__7nmSS`,
	"banner_pic_wrapper": `Banner_banner_pic_wrapper__sDvc+`,
	"container": `Banner_container__yH8MD`,
	"reg": `Banner_reg__hctpL`,
	"platforms": `Banner_platforms__5bDmO`,
	"banner": `Banner_banner__C5Dci`,
	"bannerDesk": `Banner_bannerDesk__pjaIy`
};
export default ___CSS_LOADER_EXPORT___;
